// The loading screen. index.html shows it before any script runs (styles in
// public/boot.css); this fills its progress bar and removes it once the
// assets are ready. Pages without it in their HTML (the dev demo) get one
// made here.

const MARKUP = `
  <div class="boot-card">
    <h1>Wizard Poker</h1>
    <p class="boot-sub">// warming up the back room</p>
    <div class="boot-bar"><span></span></div>
    <p class="boot-step">Loading…</p>
  </div>`;

export interface LoadingScreen {
  /** fraction 0..1, and what is loading now. */
  progress(fraction: number, step: string): void;
  /** Fade out and remove. */
  done(): void;
}

export function loadingScreen(): LoadingScreen {
  let el = document.getElementById("boot");
  if (!el) {
    if (!document.querySelector('link[href="/boot.css"]')) {
      const css = document.createElement("link");
      css.rel = "stylesheet";
      css.href = "/boot.css";
      document.head.append(css);
    }
    el = document.createElement("div");
    el.id = "boot";
    el.setAttribute("role", "progressbar");
    el.setAttribute("aria-label", "Loading Wizard Poker");
    el.setAttribute("aria-valuemin", "0");
    el.setAttribute("aria-valuemax", "100");
    el.innerHTML = MARKUP;
    document.body.prepend(el);
  }
  const root = el;
  const bar = root.querySelector<HTMLElement>(".boot-bar span");
  const label = root.querySelector<HTMLElement>(".boot-step");
  let finished = false;
  return {
    progress(fraction, step) {
      if (finished) return;
      const pct = Math.round(Math.max(0, Math.min(1, fraction)) * 100);
      if (bar) bar.style.width = `${pct}%`;
      if (label) label.textContent = `${step} ${pct}%`;
      root.setAttribute("aria-valuenow", String(pct));
    },
    done() {
      if (finished) return;
      finished = true;
      root.classList.add("done");
      root.setAttribute("aria-valuenow", "100");
      setTimeout(() => root.remove(), 400);
    },
  };
}
